// extracted by mini-css-extract-plugin
module.exports = {"screenshot-container":"Screenshot-module--screenshot-container--zOCYM","screenshot":"Screenshot-module--screenshot--30lff"};